/** Keep a leading +, strip spaces / dashes / parentheses. */
export function normalizeMobileNumber(value) {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  const hasPlus = raw.startsWith('+');
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  return hasPlus ? `+${digits}` : digits;
}
